package org.multiplatform.kotfolio.feature

import kotlinx.collections.immutable.ImmutableList
import kotlinx.collections.immutable.persistentListOf
import org.multiplatform.kotfolio.domain.Blog
import org.multiplatform.kotfolio.domain.Language
import org.multiplatform.kotfolio.domain.Topic

data class BlogDiscoveryUIState(
    val languages: ImmutableList<Language>,
    val selectedLanguage: Language?,
    val topics: ImmutableList<Topic>,
    val selectedTopic: Topic?,
    val tracks: ImmutableList<Blog>,
) {
    companion object {
        val Default = BlogDiscoveryUIState(
            languages = persistentListOf(),
            selectedLanguage = null,
            topics = persistentListOf(),
            selectedTopic = null,
            tracks = persistentListOf()
        )
    }
}

sealed interface BlogDiscoveryCommand {
    data class SelectLanguage(val language: Language) : BlogDiscoveryCommand
    data class SelectTopic(val topic: Topic) : BlogDiscoveryCommand
}
